import type { DropedProps } from '@9gustin/react-notion-render/dist/hoc/withContentValidation'
import type { ReactElement } from 'react'
import type { INotionBlock } from '~/types/notion'

import ListItem from './ListItem'

import './styles.scss'

interface Props {
  component: DropedProps
  notionBlock: INotionBlock
}

const ToggleList = ({ component, notionBlock }: Props): ReactElement => {
  const items = component?.config.block.items || []

  const getChildren = (blockId: string) => {
    const block = notionBlock.results.find(({ id }) => id === blockId)
    return block?.children || []
  }

  const listItems = items.map((item, index) => {
    const texts = item.content?.text

    const children = getChildren(item.id)

    return <ListItem blocks={children} key={`list-item-${index}`} texts={texts} />
  })

  return (
    <ul className="notion-toggle-list">
      {listItems.map((el, index) => (
        <li key={index}>{el}</li>
      ))}
    </ul>
  )
}

export default ToggleList
